import { defineStore } from 'pinia'
import { api, jetons } from '@/api/client'

// État de la session : qui est connecté, à quelles sociétés il est rattaché,
// et quelle marque il regarde.
//
// Le périmètre n'est PAS décidé ici. `societes` est ce que l'API rapporte
// après avoir joint `TB_UTILISATEUR_SOCIETE` ; `societeFiltre` ne sert qu'à
// réduire l'affichage. Envoyer un identifiant de société que l'API n'a pas
// rapporté ne donnerait rien — c'est la jointure qui borne, pas le paramètre.

export const useSession = defineStore('session', {
  state: () => ({
    client: null,
    societes: [],
    acces: null,
    societeFiltre: '',
    chargee: false,
    // Rapporté par /client/moi, pas déduit du stockage local : un
    // rechargement de page ne doit pas faire oublier qu'on regarde les
    // données de quelqu'un d'autre.
    apercu: false,
  }),

  getters: {
    connecte: state => !!jetons.acces(),
    // Une seule société rattachée : le filtre n'a pas lieu d'être affiché.
    filtrable: state => state.societes.length > 1,
    nomAffiche: state => {
      if (!state.client) return ''
      return [state.client.prenom, state.client.nom].filter(Boolean).join(' ')
    },
  },

  actions: {
    // Aperçu administrateur : on pose le jeton court et on charge le
    // profil. C'est /client/moi qui dira s'il s'agit bien d'un aperçu.
    async ouvrirApercu(token) {
      jetons.poserApercu(token)
      await this.charger()
    },

    async ouvrirSession(token) {
      const { data } = await api.ouvrirSession(token)
      if (data.res !== 1) {
        const e = new Error(data.motif || 'TOKEN_UNKNOWN')
        e.motif = data.motif
        throw e
      }
      jetons.poser(data.acces, data.rafraichissement)
      await this.charger()
    },

    async charger() {
      const { data } = await api.moi()
      if (data.res !== 1) throw new Error('profil indisponible')
      this.client = data.client
      this.societes = data.societes || []
      this.acces = data.acces || null
      this.apercu = data.apercu === true
      this.chargee = true
    },

    deconnecter() {
      jetons.effacer()
      this.$reset()
    },

    // Paramètres communs aux quatre listes : le filtre société, s'il y en a
    // un. Centralisé pour qu'aucune vue n'invente sa propre convention.
    parametres() {
      return this.societeFiltre ? { societe: this.societeFiltre } : {}
    },
  },
})
